<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="noLeidas > 0 ? noLeidas : null"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Notificaciones
        </h4>
        <b-badge
          v-if="noLeidas > 0"
          pill
          variant="light-primary"
        >
          {{ noLeidas }} sin leer
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Loading -->
      <div
        v-if="loading"
        class="text-center p-2"
      >
        <b-spinner small />
      </div>

      <!-- Empty state -->
      <div
        v-else-if="items.length === 0"
        class="text-center p-2 text-muted"
      >
        <small>No hay notificaciones</small>
      </div>

      <!-- Notification items -->
      <b-link
        v-for="notif in items"
        :key="notif.id"
        @click="handleClick(notif)"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="tipoVariant(notif.tipo)"
            >
              <feather-icon :icon="tipoIcon(notif.tipo)" />
            </b-avatar>
          </template>
          <p
            class="media-heading"
            :class="{ 'font-weight-bolder': !notif.leida }"
          >
            {{ notif.mensaje }}
          </p>
          <small class="notification-text">{{ formatFecha(notif.created_at) }}</small>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <!-- Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="marcarTodas"
      >
        Marcar todas como leídas
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BSpinner,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import {
  computed, onMounted, onUnmounted, getCurrentInstance,
} from '@vue/composition-api'
import notificacionesModule from '@/store/notificaciones'

const STORE_MODULE = 'notificaciones'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    BButton,
    BSpinner,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { proxy: root } = getCurrentInstance()

    // Registrar módulo si no existe ya
    if (!root.$store.hasModule(STORE_MODULE)) {
      root.$store.registerModule(STORE_MODULE, notificacionesModule)
    }

    // Estado del store
    const items = computed(() => root.$store.state[STORE_MODULE].items)
    const loading = computed(() => root.$store.state[STORE_MODULE].loading)
    const noLeidas = computed(() => root.$store.getters[`${STORE_MODULE}/noLeidas`])

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    // Variante de color según tipo
    const tipoVariant = tipo => {
      const map = {
        stock_listo: 'light-success',
        recepcion_completada: 'light-info',
        alerta: 'light-warning',
        error: 'light-danger',
      }
      return map[tipo] || 'light-primary'
    }

    // Icono según tipo
    const tipoIcon = tipo => {
      const map = {
        stock_listo: 'CheckIcon',
        recepcion_completada: 'PackageIcon',
        alerta: 'AlertTriangleIcon',
        error: 'XIcon',
      }
      return map[tipo] || 'BellIcon'
    }

    // Formato de fecha legible
    const formatFecha = fecha => {
      if (!fecha) return ''
      const d = new Date(fecha)
      return d.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }

    // Click en notificación: marcar leída y navegar
    const handleClick = notif => {
      if (!notif.leida) {
        root.$store.dispatch(`${STORE_MODULE}/marcarLeida`, notif.id)
      }
      if (notif.url) {
        root.$router.push(notif.url).catch(() => {})
      }
    }

    // Marcar todas como leídas
    const marcarTodas = () => {
      root.$store.dispatch(`${STORE_MODULE}/marcarTodasLeidas`)
    }

    // Polling cada 60 segundos
    let pollingTimer = null

    const fetchData = () => {
      root.$store.dispatch(`${STORE_MODULE}/fetchNotificaciones`)
    }

    onMounted(() => {
      fetchData()
      pollingTimer = setInterval(fetchData, 60000)
    })

    onUnmounted(() => {
      if (pollingTimer) clearInterval(pollingTimer)
    })

    return {
      items,
      loading,
      noLeidas,
      perfectScrollbarSettings,
      tipoVariant,
      tipoIcon,
      formatFecha,
      handleClick,
      marcarTodas,
    }
  },
}
</script>

<style>

</style>
